import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { styled } from "@mui/material/styles";
import MuiTextareaAutosize from "@mui/material/TextareaAutosize";
import { type ReactNode } from "react";
import type { FormControlLabelProps } from "@/components/common/formElements/library/FormControlLabel";

export const StyledFormControl = styled(FormControl)(() => ({
  position: "relative",
}));

export const StyledInputLabel = styled(InputLabel)(() => ({
  position: "relative",
  transform: "none",
  marginBottom: 1,
}));

export const StyledTextAreaContainer = styled("div")(() => ({
  position: "relative",
}));

export const StyledAdornmentContainer = styled("div")(() => ({
  position: "absolute",
  right: "14px",
  top: "8px",
  display: "flex",
  gap: "8px",
}));

export const StyledTextareaAutosize = styled(MuiTextareaAutosize)<{
  tooltip?: ReactNode;
}>(({ theme, tooltip }) => ({
  width: "100%",
  ...theme.typography.body1,
  padding: tooltip ? "16px 32px 16px 16px" : "16px",
  borderRadius: "4px",
  color: "inherit",
  background: "inherit",

  borderColor:
    "rgba(var(--informa-mui-palette-common-onBackgroundChannel) / 0.23)",
  "&:focus": {
    borderColor: theme.vars.palette.primary.main,
    outline: "none",
  },
  "&.error": {
    borderColor: theme.vars.palette.error.dark,
  },
}));
